export const listForShipmentBy = [
    { name: "Air", value: "AIR" },
    { name: "Sea", value: "SEA" }
]
